// Utility function to format numbers with commas
export const formatAmountWithCommas = (amount: string | undefined): string => {
  if (!amount) return "";

  // Extract numeric part from the string (handles currency symbols, spaces, etc.)
  const numericMatch = amount.match(/[\d,]+\.?\d*/);
  if (!numericMatch) return amount; // Return original if no numbers found

  const numericPart = numericMatch[0];
  const numericValue = parseFloat(numericPart.replace(/,/g, ""));

  if (isNaN(numericValue)) return amount;

  // Format with commas and replace the numeric part in the original string
  const formattedNumber = numericValue.toLocaleString();
  return amount.replace(numericPart, formattedNumber);
};

